import React, { Component } from 'react';

class ChubuTop extends Component {
  render() {
    return (
      <div className="Chubu-top pref">
        <div>石川</div>
        <div>富山</div>
        <div>新潟</div>
      </div>
    );
  }
}

class ChubuMid extends Component {
  render() {
    return (
      <div className="Chubu-mid pref">
        <div>福井</div>
        <div>岐阜</div>
        <div>長野</div>
      </div>
    );
  }
}

class ChubuBot extends Component {
  render() {
    return (
      <div className="Chubu-bot pref">
        <div>愛知</div>
        <div>静岡</div>
        <div>山梨</div>
      </div>
    );
  }
}

class Chubu extends Component {

  render() {

    return (
      <div className="Chubu">
        <ChubuTop />
        <ChubuMid />
        <ChubuBot />
      </div>
    );
  }

}

export default Chubu;
